<template>
  <div>
    <span
      @click="onClickWrapper"
      class="checkbox-wrapper"
    >
      <input
        type="checkbox"
        ref="input"
        :value="agreedTerms"
        @change="onChange"
      />
      <span class="checkbox"></span>
      <span v-if="readTerms">{{ $t('common.agreeTerms') }}</span>
      <span v-else>{{ $t('common.confirmTerms') }}</span>
    </span>
    <proa-modal
      :modal="confirmeTermsModal"
      :title="$t('common.modals.confirmTermsModal.title')"
      fluid
      @close="toggleConfirmTermsModal(false, true)"
    >
      <div class="d-flex flex-column h-100">
        <div class="font-weight-w6 text-left">{{ $t('common.modals.confirmTermsModal.caption') }}</div>
        <div class="terms-flex-wrapper">
          <div
            class="contents-wrapper"
            ref="termsContentsWrapper"
            @scroll="onScrollTermsWrapper"
          >
            <div ref="termsContens">
              <terms-of-service-content sm/>
              <privacy-policy-content sm class="mt-5 pt-5"/>
            </div>
          </div>
        </div>
      </div>
      <template slot="footer">
        <proa-button
          :disabled="!readTerms"
          @click.native="toggleConfirmTermsModal(false)"
        >
          {{ $t('common.modals.confirmTermsModal.confirmedButton') }}
        </proa-button>
      </template>
    </proa-modal>
  </div>
</template>

<script>
import PrivacyPolicyContent from '@/components/molecules/PrivacyPolicyContent.vue'
import TermsOfServiceContent from '@/components/molecules/TermsOfServiceContent.vue'

export default {
  name: 'ConfirmTermsCheckBox',
  props: {
    agreedTerms: Boolean
  },
  components: {
    PrivacyPolicyContent,
    TermsOfServiceContent
  },
  data() {
    return {
      confirmeTermsModal: false,
      readTerms: false
    }
  },
  methods: {
    onChange: function() {
      this.$emit('onChange')
      this.$nextTick(() => {
        if (!this.agreedTerms) {
          this.readTerms = false
        }
      })
    },
    onClickWrapper: function() {
      if (this.readTerms) {
        this.$refs.input.click()
      } else {
        this.toggleConfirmTermsModal(true)
      }
    },
    // NOTE: -80は上下の40pxのpadding分
    onScrollTermsWrapper: function() {
      if (this.readTerms ) return
      if (this.$refs.termsContens.offsetHeight - (this.$refs.termsContentsWrapper.offsetHeight + this.$refs.termsContentsWrapper.scrollTop - 80) <= 10) {
        this.readTerms = true
      }
    },
    toggleConfirmTermsModal: function(toggle, resetRead) {
      if (resetRead) {
        this.readTerms = false
      }
      this.confirmeTermsModal = toggle
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";

.checkbox-wrapper {
  cursor: pointer;
}

input[type="checkbox"] {
  display: none;
}

.checkbox {
  box-sizing: border-box;
  display: inline-block;
  padding: 5px 17px;
  position: relative;
  width: auto;
}
.checkbox::before {
  content: '';
  display: block;
  height: 16px;
  left: 5px;
  margin-top: -8px;
  position: absolute;
  top: 50%;
  width: 16px;
  border: 2px solid $dark-border-color;
  border-radius: 50%;
  background-color: white;
}
.checkbox::after {
  content: '';
  border-right: 2.5px solid white;
  border-bottom: 2.5px solid white;
  display: block;
  height: 10px;
  width: 6px;
  left: 10px;
  margin-top: -6px;
  opacity: 0;
  position: absolute;
  top: 50%;
  transform: rotate(45deg);
}

input[type=checkbox]:checked + .checkbox::before {
  border: none;
  background-color: $secondary-color;
}

input[type=checkbox]:checked + .checkbox::after {
  opacity: 1;
}

.terms-flex-wrapper {
  display: flex;
  flex-direction: column;
  height: calc(100% - 20px);
}

.contents-wrapper {
  text-align: left;
  margin-top: 20px;
  padding: 40px;
  box-shadow: 0px 0px 4px #00000026;
  border-radius: 4px;
  overflow: auto;
}
</style>
